import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { checkOnboardingStatus } from '@/lib/supabase';
import { supabase } from '@/integrations/supabase/client';

// Query key for onboarding status
export const onboardingStatusKey = (userId: string) => ['onboardingStatus', userId];


export function useOnboardingStatus(userId?: string) {
  const queryClient = useQueryClient();

  // Query to fetch onboarding status
  const query = useQuery({
    queryKey: userId ? onboardingStatusKey(userId) : ['onboardingStatus'],
    queryFn: async () => {
      if (!userId) return false;
      return await checkOnboardingStatus(userId);
    },
    enabled: !!userId,
    staleTime: 1000 * 60 * 5, // 5 minutes
    retry: 3, // Retry failed requests 3 times
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff with a max of 30 seconds
  });

  // // Set up a realtime subscription to user_subscriptions table changes
  // useEffect(() => {
  //   if (!userId) return;

  //   // Subscribe to changes in the user_subscriptions table for this user
  //   const subscription = supabase
  //     .channel(`user_subscription_${userId}`)
  //     .on(
  //       'postgres_changes',
  //       {
  //         event: 'UPDATE',
  //         schema: 'public',
  //         table: 'user_subscriptions',
  //         filter: `user_id=eq.${userId}`,
  //       },
  //       (payload) => {
  //         // When we get an update for this user's subscription,
  //         // invalidate the query cache to trigger a refetch
  //         console.log('Subscription update received:', payload);
          
  //         // Check if the is_onboarded field has changed to true
  //         if (payload.new && payload.new.is_onboarded === true) {
  //           // Immediately update the cache
  //           queryClient.setQueryData(onboardingStatusKey(userId), true);
            
  //           // Also invalidate to trigger a refetch for the latest data
  //           queryClient.invalidateQueries({ queryKey: onboardingStatusKey(userId) });
  //         }
  //       }
  //     )
  //     .subscribe();

  //   // Clean up the subscription when the component unmounts
  //   return () => {
  //     supabase.removeChannel(subscription);
  //   };
  // }, [userId, queryClient]);

  // Add a manual function to force a refresh of the onboarding status
  const refreshOnboardingStatus = () => {
    if (userId) {
      queryClient.invalidateQueries({ queryKey: onboardingStatusKey(userId) });
    }
  };

  // Function to optimistically update onboarding status before webhook completes
  const setOnboardedOptimistically = () => {
    if (userId) {
      // Set the cache immediately to true
      queryClient.setQueryData(onboardingStatusKey(userId), true);
      
      // Add a toast message or other UI feedback if needed
      console.log('Optimistically updated onboarding status to true');
      
      return true;
    }
    return false;
  };

  return {
    isOnboarded: query.data ?? false,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refreshOnboardingStatus, // Function to manually refresh the status
    setOnboardedOptimistically, // Function to optimistically update status
  };
}
